/**
 * @flow
 * @relayHash 5dfe04b00807870475aabd29c8bf40c1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AvailabilityCheckerContainer_viewer$ref = any;
export type AvailabilityCheckerContainer_RefetchQueryVariables = {|
  afterTime: any,
  beforeTime: any,
  returnEmptyConnection?: ?boolean,
|};
export type AvailabilityCheckerContainer_RefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: AvailabilityCheckerContainer_viewer$ref
  |}
|};
export type AvailabilityCheckerContainer_RefetchQuery = {|
  variables: AvailabilityCheckerContainer_RefetchQueryVariables,
  response: AvailabilityCheckerContainer_RefetchQueryResponse,
|};
*/


/*
query AvailabilityCheckerContainer_RefetchQuery(
  $afterTime: ISO8601Type!
  $beforeTime: ISO8601Type!
  $returnEmptyConnection: Boolean
) {
  viewer {
    ...AvailabilityCheckerContainer_viewer_2Pfr0E
    id
  }
}

fragment AvailabilityCheckerContainer_viewer_2Pfr0E on User {
  ...AvailabilityCalendarContainer_viewer
  s_time_zone
  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment AvailabilityCalendarContainer_viewer on User {
  s_time_zone
  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {
    edges {
      node {
        event {
          id
          title
        }
        booking_status
        start_at
        end_at
        user_event_segments(first: 99999) {
          edges {
            node {
              title
              start_at
              end_at
              all_day
              location
              room
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "afterTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "beforeTime",
    "type": "ISO8601Type!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "returnEmptyConnection",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 99999,
  "type": "Int"
},
v2 = {
  "kind": "Literal",
  "name": "visibility",
  "value": [
    "SHOW"
  ],
  "type": "[UserEventVisibility]"
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "start_at",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "end_at",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "UserEventEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "UserEvent",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": null,
            "concreteType": "Event",
            "plural": false,
            "selections": [
              v3,
              v4
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "booking_status",
            "args": null,
            "storageKey": null
          },
          v5,
          v6,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user_event_segments",
            "storageKey": "user_event_segments(first:99999)",
            "args": [
              v1
            ],
            "concreteType": "UserEventSegmentConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "UserEventSegmentEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserEventSegment",
                    "plural": false,
                    "selections": [
                      v4,
                      v5,
                      v6,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "all_day",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "location",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "room",
                        "args": null,
                        "storageKey": null
                      },
                      v3
                    ]
                  }
                ]
              }
            ]
          },
          v3
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AvailabilityCheckerContainer_RefetchQuery",
  "id": null,
  "text": "query AvailabilityCheckerContainer_RefetchQuery(\n  $afterTime: ISO8601Type!\n  $beforeTime: ISO8601Type!\n  $returnEmptyConnection: Boolean\n) {\n  viewer {\n    ...AvailabilityCheckerContainer_viewer_2Pfr0E\n    id\n  }\n}\n\nfragment AvailabilityCheckerContainer_viewer_2Pfr0E on User {\n  ...AvailabilityCalendarContainer_viewer\n  s_time_zone\n  AvailabilityCheckerContainer_user_events: user_events(first: 99999, visibility: [SHOW], return_empty_connection: $returnEmptyConnection, after_time: $afterTime, before_time: $beforeTime) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment AvailabilityCalendarContainer_viewer on User {\n  s_time_zone\n  AvailabilityCalendarContainer_user_events: user_events(first: 99999, visibility: [SHOW], booking_status: [BOOKED, INITIAL, CANCELED], return_empty_connection: true) {\n    edges {\n      node {\n        event {\n          id\n          title\n        }\n        booking_status\n        start_at\n        end_at\n        user_event_segments(first: 99999) {\n          edges {\n            node {\n              title\n              start_at\n              end_at\n              all_day\n              location\n              room\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AvailabilityCheckerContainer_RefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "AvailabilityCheckerContainer_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "afterTime",
                "variableName": "afterTime",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "beforeTime",
                "variableName": "beforeTime",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "returnEmptyConnection",
                "variableName": "returnEmptyConnection",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AvailabilityCheckerContainer_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "s_time_zone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCalendarContainer_user_events",
            "name": "user_events",
            "storageKey": "user_events(booking_status:[\"BOOKED\",\"INITIAL\",\"CANCELED\"],first:99999,return_empty_connection:true,visibility:[\"SHOW\"])",
            "args": [
              {
                "kind": "Literal",
                "name": "booking_status",
                "value": [
                  "BOOKED",
                  "INITIAL",
                  "CANCELED"
                ],
                "type": "[BookingStatus]"
              },
              v1,
              {
                "kind": "Literal",
                "name": "return_empty_connection",
                "value": true,
                "type": "Boolean"
              },
              v2
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v7
          },
          {
            "kind": "LinkedField",
            "alias": "AvailabilityCheckerContainer_user_events",
            "name": "user_events",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after_time",
                "variableName": "afterTime",
                "type": "ISO8601Type"
              },
              {
                "kind": "Variable",
                "name": "before_time",
                "variableName": "beforeTime",
                "type": "ISO8601Type"
              },
              v1,
              {
                "kind": "Variable",
                "name": "return_empty_connection",
                "variableName": "returnEmptyConnection",
                "type": "Boolean"
              },
              v2
            ],
            "concreteType": "UserEventConnection",
            "plural": false,
            "selections": v7
          },
          v3
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f4c1acd81ced34528cc6a3ba03b860cd';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityChecker/__generated__/AvailabilityCheckerContainer_RefetchQuery.graphql.js